import PropTypes from 'prop-types';

import { Stack, Typography, Card } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from '../../common/LocalizationProvider';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(1, 0),
  color: theme.palette.success.darker,
  backgroundColor: theme.palette.success.lighter
}));

AerosDetailsMainInfos.propTypes = {
  aero: PropTypes.object
};
export default function AerosDetailsMainInfos({ aero }) {
  const t = useTranslation();
  const { nom, oaci } = aero;
  return (
    <RootStyle>
      <Stack direction="column" justifyContent="center" alignItems="center">
        <Typography variant="h5" paddingTop={1}>
          {t('general_infos')}
        </Typography>
      </Stack>
      <Stack direction="column" justifyContent="center" alignItems="center" sx={{ p: 3 }}>
        <Typography variant="h4">{`${oaci} - ${nom}`}</Typography>
      </Stack>
    </RootStyle>
  );
}
